/**
 * Används för att skapa en wrapper runt schemas, för att kunna styla formulär genererade via schema på samma sätt som
 * de som skapas utan schema (pga att Formulate dumpar ut schemabaserade formulär utanför targettable slot...)
 * Värden satta i addToAll kommer automatiskt läggas till på alla children
 */
export const generateSchema: (props: {
    schema: Array<{ [key: string]: unknown }>;
    addToAll: { [key: string]: string | number | boolean };
}) => { [key: string]: unknown }[] = ({ schema, addToAll }) => {
    return [
        {
            component: "div",
            class: "form-content-wrapper",
            children: [
                {
                    component: "div",
                    class: "form-content",
                    children: schema.map((item) => ({
                        ...item,
                        ...addToAll,
                    })),
                },
            ],
        },
    ];
};
